import { PolicyPageLayout } from "./PolicyPageLayout";

export const QualityPolicyPage = () => {
  return (
    <PolicyPageLayout
      eyebrow="Arihant Infracon"
      title="Quality Policy"
      sections={[
        {
          title: "Policy Statement",
          body: [
            "Arihant Infracon is committed to delivering construction, infrastructure, finishing, facade, MEP and airside works that consistently meet or exceed client expectations, statutory requirements and applicable international standards. Quality is an integral part of our organizational culture and a fundamental pillar of our project execution philosophy.",
            "We believe that quality is not an isolated activity but a systematic process embedded across planning, design coordination, procurement, execution, inspection, testing and final handover stages.",
          ],
        },
        {
          title: "Quality Objectives",
          bullets: [
            "Deliver defect-free construction and finishing works in compliance with approved drawings and specifications.",
            "Ensure strict adherence to contractual, statutory and regulatory requirements.",
            "Implement a robust Project Quality Plan (PQP) for every project.",
            "Achieve continual improvement through monitoring, audits and corrective actions.",
            "Enhance client satisfaction through predictable quality outcomes.",
          ],
        },
        {
          title: "Quality Management System",
          body: [
            "Arihant Infracon operates a structured Quality Management System aligned with ISO 9001:2015, encompassing:",
          ],
          bullets: [
            "Defined quality processes and responsibilities.",
            "Inspection & Test Plans (ITPs) for all major activities.",
            "Material Approval Requests (MAR/MIR) and Work Inspection Requests (WIR).",
            "Control of drawings, documents and records.",
            "Non-Conformance Reporting (NCR) and corrective/preventive actions.",
          ],
        },
        {
          title: "Planning & Design Coordination",
          body: [
            "Quality assurance begins at the planning and design coordination stage. Our in-house engineering and drawing coordination team ensures:",
          ],
          bullets: [
            "Proper interpretation of design intent.",
            "Clash-free shop drawings.",
            "Constructability reviews prior to execution.",
            "Interface coordination between civil, finishing, facade and MEP disciplines.",
          ],
        },
        {
          title: "Procurement & Vendor Quality",
          body: ["We ensure quality through:"],
          bullets: [
            "Selection of approved vendors and manufacturers.",
            "Compliance with approved makes and specifications.",
            "Incoming material inspections and test certifications.",
            "Traceability of critical materials.",
          ],
        },
        {
          title: "Execution & Inspection",
          body: ["Quality during execution is ensured through:"],
          bullets: [
            "Stage-wise inspections.",
            "Mock-ups for critical finishes.",
            "Continuous supervision by QA/QC personnel.",
            "Coordination with client/PMC for approvals.",
          ],
        },
        {
          title: "Continual Improvement",
          body: ["We are committed to continual improvement by:"],
          bullets: [
            "Conducting internal quality audits.",
            "Analysing non-conformities and root causes.",
            "Implementing corrective and preventive actions.",
            "Reviewing quality performance at management level.",
          ],
        },
        {
          title: "Management Commitment",
          body: [
            "Top management is fully committed to providing resources, training and leadership to ensure effective implementation of this Quality Policy across all projects.",
          ],
        },
      ]}
    />
  );
};
